export default __webpack_public_path__ + "static/media/flag-sao-tome-and-principe.658d6305.svg";